// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const codiceFiscale: CountryValidator<
  "IT",
  ParsedPersonId
> = createValidator("it.codiceFiscale", 105);

export default codiceFiscale;
export const compact = codiceFiscale.compact;
export const format = codiceFiscale.format;
export const validate = codiceFiscale.validate;
export const generate = (): string =>
  codiceFiscale.generate?.() ??
  (() => {
    throw new Error(
      "Validator it.codiceFiscale cannot generate values",
    );
  })();
export const parse = codiceFiscale.parse;
